<template>
    <div>
        <div class="page">
            <!-- <div class="btn-list">
                <div :class="['btn-item', btnIndex == 1 ? 'btn-select' : '']" @click="changeBtnIndex(1)">全部</div>
                <div :class="['btn-item', btnIndex == 2 ? 'btn-select' : '']" @click="changeBtnIndex(2)">未读</div>
                <div :class="['btn-item', btnIndex == 3 ? 'btn-select' : '']" @click="changeBtnIndex(3)">已读</div>
            </div> -->

            <div class="content">
                <div class="content-head">
                    我的消息
                </div>
                <div class="content-wrap">
                    <div class="message-item" v-for="item in messageList" :key="item.id">
                        <div class="item-title">{{ item.title }}</div>
                        <div class="item-mes">
                            {{ item.content }}
                        </div>

                        <div class="item-b" @click="openDetail(item)">
                            查看详情
                        </div>
                    </div>

                    <div
                        :style="{
                            width: '100%',
                            padding: '50px 0 50px 0',
                            borderBottom: '1px solid rgba(232, 232, 232, 1)'
                        }"
                        class="f-r-cc"
                        v-if="messageList.length == 0"
                    >
                        <Empty description="暂无数据" />
                    </div>
                </div>
            </div>

            <MesModal ref="mesModal"></MesModal>
        </div>
    </div>
</template>

<script>
import { Message } from "ant-design-vue";
import MesModal from "./component/mesModal.vue";
import { getAction } from "@/util/require.js";
export default {
    name: "",
    components: {
        MesModal,
    },
    data() {
        return {
            btnIndex: 1,
            messageList: []
        };
    },
    created() {
        this.getData();
    },
    mounted() {
        this.$store.commit('changeMessageDot', false)
    },
    methods: {
        getData() {
            getAction("/hq/webPage/checkMyMessage").then(res => {
                if (res.success) {
                    this.messageList = res.result;
                }
            });
        },
        changeBtnIndex(index) {
            this.btnIndex = index;
        },
        openDetail(item) {
            this.$refs.mesModal.openModal(item);
        }
    }
};
</script>

<style scoped lang="scss">
.page {
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    box-shadow: 0px 7px 24px 0px rgba(8, 124, 232, 0.15);
    border-radius: 2px;
    min-height: 800px;
    background: #fff;
}

.btn-list {
    margin: 20px 30px 0 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .btn-item {
        width: 140px;
        height: 60px;
        border: 1px solid #087ce8;
        box-sizing: border-box;
        text-align: center;
        font-size: 22px;
        font-weight: 400;
        color: #087ce8;
        line-height: 60px;
        cursor: pointer;
        &:nth-child(n + 2) {
            border-left: none;
        }
    }
    .btn-select {
        background: #087ce8;
        color: #fff;
        font-weight: 500;
    }
}
.content {
    margin: 20px 0 0 30px;
    width: calc(100% - 60px);
    min-height: 500px;
    .content-head {
        width: 100%;
        height: 53px;
        background: #f0f4f9;
        border: 1px solid #dfdfdf;
        border-radius: 2px;
        font-size: 18px;
        font-weight: bold;
        color: #262626;
        line-height: 53px;
        text-indent: 30px;
        position: relative;
        &::before {
            content: "";
            width: 2px;
            height: 20px;
            background: #1976f8;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 20px;
        }
    }
    .content-wrap {
        border: 1px solid rgba(232, 232, 232, 1);
        border-bottom: none;
        width: 100%;
        .message-item {
            position: relative;
            background: #fff;
            padding: 24px 20px 28px;
            border-bottom: 1px solid rgba(232, 232, 232, 1);
            .item-title {
                font-size: 20px;
                font-weight: bold;
                color: #333333;
                line-height: 1;
                width: 100%;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }
            .item-mes {
                margin-top: 13px;
                font-size: 14px;
                font-family: PingFang;
                font-weight: 400;
                color: #666666;
                width: calc(100% - 70px);
                line-height: 1;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }
            .item-b {
                font-size: 14px;
                font-family: PingFang;
                font-weight: 400;
                color: #087ce8;
                line-height: 30px;
                height: 30px;
                width: 70px;
                text-align: center;
                position: absolute;
                right: 10px;
                bottom: 20px;
                cursor: pointer;
                &:hover {
                    text-shadow: 0px 0px 1px rgba(8, 124, 232, 0.8);
                }
            }
        }
    }
}
</style>
